module.exports = __webpack_public_path__ + "static/media/tdd-cycle.13e0a1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/03-test-driven-development/images/tdd-cycle.png
// module id = 875
// module chunks = 0